export default {"src":"/_next/static/media/catalog-search-close.217417a2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};